export default "__VITE_ASSET__DaxggSkI__"